import Factory from '../factory';

const schema = Factory.schema('organisational-structure');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('btnLabel').setType(String).setValue('The United Nations Systems');
attributes.prop('btnSrc').setType(String);

export default schema;
